//libraries
import Vue from 'vue'
import axios from 'axios'

let resource = 'entity'
let resource_name = 'entidad'
let resource_name_plural = 'entidades'

let state = {
  entities: [],
  attributes: [],
}

//functions receive state
let getters = {

}

//functions receive context and params
let actions = {
  async all ({ commit }, params) {
    try {
      commit('setItems', [])
      let res = await Vue.request.get(`account/${params.account_id}/entities`, {params: params.params || {}})
      if(res.data.success) {
        commit('setItems', res.data.resource)
        if(params.callback)
          params.callback(res.data)
      } else {
        if(params.callback)
          params.callback({error: `Error obteniendo ${resource_name_plural}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name_plural}.`})
      console.error(e)
    }
  },
  async get ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name}.`})
      console.error(e)
    }
  },
  async create ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}`, params)
      if(res.data.success && params.callback) {
        commit('pushItem', res.data)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error creando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error creando ${resource_name}.`})
      console.error(e)
    }
  },
  async update ({ commit }, params) {
    try {
      let res = await Vue.request.patch(`${resource}/${params.entity_id}`, params)
      if(res.data.success && params.callback) {
        commit('updateItem', res.data.resource)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error actualizando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error actualizando ${resource_name}.`})
      console.error(e)
    }
  },
  async destroy ({ commit }, params) {
    try {
      let res = await Vue.request.delete(`${resource}/${params.entity_id}`)
      if(res.data.success && params.callback) {
        commit('removeItem', params)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error eliminando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error eliminando ${resource_name}.`})
      console.error(e)
    }
  },
  //ASIGN ENTITIE TO ACCOUNT
  async assign ({ commit }, params) {
    try {
      //account_id in body
      let res = await Vue.request.post(`${resource}/${params[resource + '_id']}/associateAccount`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error asociando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error asociando ${resource_name}.`})
      console.error(e)
    }
  },
  //REMOVE ENTITIE TO ACCOUNT
  async remove ({ commit }, params) {
    try {
      //account_id in body
      let res = await Vue.request.post(`${resource}/${params[resource + '_id']}/disassociateAccount`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error desasociando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error desasociando ${resource_name}.`})
      console.error(e)
    }
  },
  //ENTITY ATRIBUTES
  async attributes ({ commit }, params) {
    try {
      commit('setAttributes', [])
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}/attributes`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        commit('setAttributes', res.data.resource)
        params.callback(res.data)
      } else {
        if(params.callback)
          params.callback({error: `Error obteniendo atributos de ${resource_name_plural}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo atributos de ${resource_name}.`})
      console.error(e)
    }
  },
  async create_attribute ({ commit }, params) {
    try {
      let res = await Vue.request.post(`attribute`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error creando atributo de ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error creando atributo de ${resource_name}.`})
      console.error(e)
    }
  },
  async update_attribute ({ commit }, params) {
    try {
      let res = await Vue.request.patch(`attribute/${params.attribute_id}`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error actualizando atributo de ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error actualizando atributo de ${resource_name}.`})
      console.error(e)
    }
  },
  async destroy_attribute ({ commit }, params) {
    try {
      let res = await Vue.request.delete(`attribute/${params.attribute_id}`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error eliminando atributo de ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error eliminando atributo de ${resource_name}.`})
      console.error(e)
    }
  },
  //ENTITY VALUES
  async values ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}/${params[resource + '_id']}/values`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else {
        if(params.callback)
          params.callback({error: `Error obteniendo valores de ${resource_name_plural}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo valores de ${resource_name}.`})
      console.error(e)
    }
  },
  async create_row ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}/row`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error creando renglón de ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error creando renglón de ${resource_name}.`})
      console.error(e)
    }
  },
  async update_row ({ commit }, params) {
    try {
      let res = await Vue.request.patch(`${resource}/${params[resource + '_id']}/row/${params._id}`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error actualizando valor de ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error actualizando valor de ${resource_name}.`})
      console.error(e)
    }
  },
  async delete_row ({ commit }, params) {
    try {
      let res = await Vue.request.delete(`${resource}/${params[resource + '_id']}/row/${params._id}`, {data: params})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error eliminando valor de ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error eliminando valor de ${resource_name}.`})
      console.error(e)
    }
  },
  async file ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}/parseCSV`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: res.data.error_message ? res.data.error_message : `Error subiendo archivo.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error subiendo archivo.`})
      console.error(e)
    }
  },
}

//functions receive state
let mutations = {
  setItems (state, items) {
    state.entities = items
  },
  setAttributes (state, items) {
    state.attributes = items
  },
  pushItem (state, data) {
    if (data.success) {
      state.entities.push(data.resource)
    }
  },
  updateItem (state, item) {
    let index = state.entities.findIndex(el => el[resource + '_id'] === item[resource + '_id'])
    if(index) {
      state.entities.splice(index, 1, item)
    }
  },
  removeItem(state, item) {
    let index = state.entities.findIndex(el => el[resource + '_id'] === item[resource + '_id'])
    if(index >= 0) {
      state.entities.splice(index, 1)
    }
  },
}

export default {
  state,
  mutations,
  actions,
  getters
}
